<template>
  <div class="transaction-overview">
    <img class="transaction-overview__logo" src="@/assets/images/header/logo.png"/>
    <TableOverview
      :title="'Transaction(s) Overview'"
      :isPagination="false"
      :customFoot="true"
      :footFields="footFields"
      :fields="fields"
      :items="transactions"
      :is-pos-device="true"
      :custom-title="'transaction-overview-title'"
    />
    <div class="transaction-overview__submit mb-3">
      <b-button class="btn-ticket btn-back-home" @click="handleBackHome">Back Home</b-button>
      <b-button class="btn-print" @click="handlePrint">Print</b-button>
    </div>
  </div>
</template>
<script>
import TableOverview from '@/components/common/table/table';
import lottoService from '@/services/lotto.service';
import toolService from '@/services/tool.service';
export default {
  components: {
    TableOverview
  },
  data() {
    return {
      ref: null,
      totalWinnings: 0,
      transactions: [],
      fields: [
        {key: 'id', label: 'Bet ID'},
        {key: 'date', label: 'Date Created'},
        {key: 'type', label: 'Type'},
        {key: 'mainNumbers', label: 'Numbers'},
        {key: 'wager', label: 'Amount'}
      ],
      footFields: [
        {value: '', label: 'Total amount due'},
        {value: '', label: 'Cash Received'},
        {value: '', label: 'Change'}
      ]
    }
  },
  computed: {
    rows() {
      return this.total
    }
  },
  created() {

    this.ref = this.$route.query.ref;
    this.received = this.$route.query.received;
    this.updateFootFields(1, this.received);

    lottoService.scanTicket(this.ref).then((res) => {
      if (res.status === 'success') {
        const transactions = res.data.transactions;
        const moneyChange = parseFloat(this.received) - parseFloat(res.data.totalWager);

        this.updateFootFields(0, res.data.totalWager);
        this.updateFootFields(2, moneyChange);

        for(const tId in transactions) {
          transactions[tId].forEach((bet, i) => {
            this.transactions.push(bet);
          })
        }
      } else {
        const message = res.message;
        this.$bvToast.toast(message, {
            title: 'Failed',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
        })
      }
    },
    () => this.$bvToast.toast('Scan Ticket failed! Please try again', {
        title: 'Failed',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000
    }));

  },
  methods: {
    handleBackHome() {
      this.$router.push('/ticket');
    },
    handlePrint() {
      parent.postMessage(JSON.stringify(this.transactions),"*");
    },
    updateFootFields(index, value) {
      this.footFields[index].value = toolService.formatAmount(parseFloat(value));
    }
  }
}
</script>
